// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"8ef827bc","481":"01e1cd3b","787":"ca364ffe","979":"1c9d5735","998":"796e8bf5"}[chunkId] + ".chunk.js";
};